import { useEffect, useRef, useCallback } from 'react';
import { animateRoute } from '../pages/tracking/map/animations/animate-route'

export default function useMapboxRouteAnimation(map) {
    const animationRef = useRef(null);

    const startAnimation = useCallback((coordinates, options) => {
        // Stop and cleanup any existing animation
        if (animationRef.current) {
            animationRef.current.stop();
            animationRef.current = null;
        }
        
        let framesWaited = 0;

        function waitUntilClean() {
            framesWaited++;
            if (framesWaited < 3) {
                requestAnimationFrame(waitUntilClean);
            } else {
                animationRef.current = animateRoute(map, coordinates, options);
            }
        }

        requestAnimationFrame(waitUntilClean);
    }, [map]);

    const stopAnimation = useCallback(() => {
        if (animationRef.current) {
            animationRef.current.stop();
        }
    }, []);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (animationRef.current) {
                animationRef.current.stop();
            }
        };
    }, []);

    return { 
        startAnimation, 
        stopAnimation,
        isAnimating: () => animationRef.current?.isAnimating() || false,
        getProgress: () => animationRef.current?.getProgress() || 0
    };
}